module.exports = __webpack_public_path__ + "assets/3bdf5ff08318e8970412d8f83ff939ad.woff2";